module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "snoindent2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("(From the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Grand Rapids")]), _vm._v(" Register, May 6, 1935)")]), _vm._v(" "), _c('p', {
    staticClass: "sindent"
  }, [_vm._v("In Mount Clemens yesterday, the wild dog problem was relieved by a local farmer, Gustave Hohenrikt, who cornered a pack of stray dogs in his barn and killed four of them with a shotgun. Mr. Hohenrikt reported the dogs had been raiding his chicken and sheep pens, and he decided to take action. Reports from Bay City also indicate wild dogs are becoming more of a nuisance there. Police Chief R. B. Matthews of that city issued a shoot on sight order for all stray dogs in rural areas. The order came after several farmers in the area reported night attacks on their livestock.")]), _vm._v(" "), _c('p', {
    staticClass: "shd"
  }, [_vm._v("SHEEP SLAYER TO DIE")]), _vm._v(" "), _c('p', {
    staticClass: "snoindent"
  }, [_vm._v("(From the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cassius Daily Post and Examiner, May 6,")]), _vm._v(" 1935)")]), _vm._v(" "), _c('p', {
    staticClass: "sindent"
  }, [_vm._v("Judge John Feldman of Circuit Court today condemned to death a sheep stealer who has been raiding local pens and has a record of several previous convictions on the same charge. The indictment charges him with slaying at least eight sheep. The condemned is a large yellow hound named Rufus, formerly owned by Mr. and Mrs. J. C. Mooresby of this city. Rufus sat in the courtroom and appeared contrite as Judge Feldman passed sentence on him. The dog will be gassed to death at the County Pound, an object lesson to other canine malefactors.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0c6d88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/xhtml/05_Part1_1.vue
// module id = 87
// module chunks = 0